import UFRegion from "./uf-region.entity";

export default class UF {
  public id: string = '';

  public sigla: string = '';

  public nome: string = '';

  public regiao: UFRegion = new UFRegion();

  constructor(data: any = {}) {
    this.id = data.id || '';
    this.sigla = data.sigla || '';
    this.nome = data.nome || '';
    this.regiao = /* istanbul ignore next */ new UFRegion(data.regiao) || new UFRegion();
  }
}
